import {
  getBackendClient,
  unwrapApiResponse,
  type ApiSchema,
  type BackendClientOptions,
} from './client'

export type UserIds = ApiSchema<'GetUserIds'>
export type User = ApiSchema<'GetUser'>
export type PutUserPayload = ApiSchema<'PutUser'>
export type Role = ApiSchema<'GetRole'>

/** Resolve the backend user id for the authenticated Firebase session. */
export async function getCurrentUserId(
  options: BackendClientOptions = {},
): Promise<UserIds> {
  const client = getBackendClient(options)
  return unwrapApiResponse(client.GET('/userids'))
}

export async function getUser(
  userId: string,
  options: BackendClientOptions = {},
): Promise<User> {
  const client = getBackendClient(options)
  return unwrapApiResponse(client.GET('/users/{user_id}', {
    params: { path: { user_id: userId } },
  }))
}

export async function updateUser(
  userId: string,
  body: PutUserPayload,
  options: BackendClientOptions = {},
): Promise<User> {
  const client = getBackendClient(options)
  return unwrapApiResponse(client.PUT('/users/{user_id}', {
    params: { path: { user_id: userId } },
    body,
  }))
}

export async function listRoles(
  options: BackendClientOptions = {},
): Promise<Role[]> {
  const client = getBackendClient(options)
  return unwrapApiResponse(client.GET('/roles'))
}
